<template>
  <div v-if="!!contract.tenant" class="pl-3">
    <div>
      <v-row class="d-flex justify-space-between">
        <v-col class="py-0" cols="6">
          <v-card outlined>
            <v-card-title class="text-h5 pb-0">
              {{
                $t("contract.show.main_panel.headers.tenant", {
                  name: contract.tenant[0].profile.name
                })
              }}
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text class="px-0">
              <div class="d-flex justify-space-between">
                <p class="pl-4">
                  {{ $t("contract.show.main_panel.headers.balance") }}
                </p>
                <strong
                  class="pr-4 text-h5"
                  :class="{ balanceColor: 5000 < 0 }"
                >
                  ${{ contract.tenantStatus }}
                </strong>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col class="py-0" cols="6">
          <v-card outlined>
            <v-card-title class="text-h5 pb-0">
              {{
                $t("contract.show.main_panel.headers.owners", {
                  name: contract.owner.map(o => o.profile.name).join(", ")
                })
              }}
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text class="px-0">
              <div class="d-flex justify-space-between">
                <p class="pl-4">
                  {{ $t("contract.show.main_panel.headers.balance") }}
                </p>
                <strong
                  class="pr-4 text-h5"
                  :class="{ balanceColor: 5000 > 0 }"
                >
                  ${{ contract.ownerStatus }}
                </strong>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-alert
        class="mt-3"
        outlined
        border="left"
        type="info"
        v-if="contract.rescission"
      >
        <v-row no-gutters align="center">
          <v-col class="grow">
            Contrato
            {{ contract.state == "finished" ? "rescindido" : "a rescindir" }}
          </v-col>
          <v-col class="shrink">
            <v-btn
              @click="$emit('openRescission')"
              depressed
              small
              color="primary"
              >Ver rescisión</v-btn
            >
          </v-col>
        </v-row>
      </v-alert>

      <MainPanel @reload="$emit('reload')" :contract="contract" />
    </div>
    <v-btn
      style="position: fixed; top: 60px"
      :style="showDetails ? 'right: 408px' : 'right: 0'"
      fab
      small
      color="primary"
      class="rounded-r-0"
      @click="showDetails = !showDetails"
    >
      <v-icon>
        {{ showDetails ? "mdi-close" : "mdi-file-document" }}
      </v-icon>
    </v-btn>
    <div
      style="position: absolute; right: 0; top: 0; height: 100%"
      class="pa-6 white"
      v-if="showDetails"
    >
      <div class="text-h6 font-weight-bold mb-3 d-flex">
        Detalles del contrato
        <v-spacer></v-spacer>
        <v-btn icon color="primary" @click="showDetails = !showDetails">
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </div>
      <PanelOne :contract="contract" />
      <PanelTwo :contract="contract" />
      <PanelThree :contract="contract" />
    </div>
  </div>
</template>

<script>
import PanelOne from "@/components/contracts/show/PanelOne";
import PanelTwo from "@/components/contracts/show/PanelTwo";
import PanelThree from "@/components/contracts/show/PanelThree";
import MainPanel from "@/components/contracts/show/MainPanel";

export default {
  name: "ContractShow",
  data: () => ({
    showDetails: false
  }),

  components: {
    PanelOne,
    PanelTwo,
    PanelThree,
    MainPanel
  },
  props: ["contract"]
};
</script>

<style scoped>
hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #e5e5e5;
  margin: 1em 0;
  padding: 0;
}
.balanceColor {
  color: #db2b39;
}
</style>
